import { render } from "./LinkNew.vue?vue&type=template&id=617c1657"
import script from "./LinkNew.vue?vue&type=script&lang=js"
export * from "./LinkNew.vue?vue&type=script&lang=js"

import "./LinkNew.vue?vue&type=style&index=0&id=617c1657&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__